import _ from 'lodash'

import { bus, helper } from '@/utils'
import TimelineModel from '../TimelineModel/TimelineModel.vue'

export default {
  components: { TimelineModel },
  methods: {
    getLogs () {
      const query = {
        args: JSON.stringify({
          tags: this.tagsFormat(this.target),
          metrics: [
            'from',
            'ip',
            'log',
            'log_type'
          ],
          limit: 5,
          start_time: this.startTime
        })
      }

      return this.$api
        .getLogs(query)
        .then(({ data }) => this.showList(data))
        .catch(error => {
          helper.showErrorMessage(this, this.component, error)
          this.lists = []
        })
    },
    openTimelineModel () {
      bus.$emit('show-timeline-model', {
        target: this.target
      })
    },
    showList ({ columns, values }) {
      if (!this.lists) {
        this.lists = []
      }

      const logs = values.map(value => {
        const item = _.zipObject(columns, value)
        let action

        try {
          action = JSON.parse(item.log)
        } catch (error) {
          helper.showErrorMessage(this, this.component, error)
          action = {}
        }

        return {
          action,
          from: item.from,
          ip: item.ip,
          type: item.log_type,
          status: this.viewLogInfo(item.status),
          time: item.time,
          identity: this.target
        }
      })

      this.lists = this.lists.concat(logs)

      return logs
    },
    tagsFormat (target) {
      return _.includes(target, '@') ? { email: target, log_type: 'event' } : { device_unique_id: target }
    },
    viewLogInfo (status) {
      let data = {}
      _.forEach(
        status,
        (value, key) => { data = Object.assign({}, data, { [key]: value }) }
      )

      return data
    }
  },
  name: 'Timeline',
  props: {
    showEventFilter: {
      default: false,
      type: Boolean
    },
    target: {
      type: [ String, Number ]
    },
    fields: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    target (newStates) {
      this.lists = null
      if (newStates) {
        this.getLogs()
      }
    }
  },
  data () {
    return {
      component: 'timeline',
      lists: null,
      startTime: helper.parseStartTime(this.$store.state.dataRetention),
      status: {}
    }
  },
  mounted () {
    if (this.target) {
      this.getLogs()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Timeline/Timeline.js